//apis
export const AI_API_URL = '/v1/AI';
export const ASSET_API_URL = '/v1/asset';
export const ASSET_SLOT_URL = '/v1/assetSlot';
export const ASSET_SLOT_EVENT_URL = '/v1/assetslotevent';
export const CEREMONY_TEMPLATE_API_URL = '/v1/ceremonytemplate';
export const CEREMONY_SLOT_TYPE_API_URL = '/v1/ceremonyslottype';
export const COVER_PHOTO_API_URL = '/v1/coverphoto';
export const DASHBOARD_API_URL = '/v1/dashboard';
export const DEVICE_API_URL = '/v1/device';
export const DEVICE_SCHEDULE_API_URL = '/v1/deviceschedule';
export const DOWNLOAD_SONG_API = '/v1/music/download';
export const EVENT_API_URL = '/v1/event';
export const IMAGE_MOVEMENTS = 'imageMovements';
export const ORGANIZATION_API_URL = '/v1/organization';
export const ORGANIZATION_BRANDING_API_URL = '/v1/organizationbranding';
export const ORGANIZATION_SETTINGS_API_URL = '/v1/organizationsettings';
export const PREVIEW_MUSIC_API_URL = '/v1/music/preview';
export const ROLE_API_URL = '/v1/role';
export const SEARCH_MUSIC_API_URL = '/v1/music/search';
export const TAGS_API_URL = '/v1/tag';
export const TRIBUTE_VIDEO_API_URL = '/v1/tributevideo';
export const USER_API_URL = '/v1/user';
export const VIDEO_THEME_API_URL = '/v1/videotheme';
export const CUSTOM_VIDEO_THEME_API_URL = '/v1/customvideotheme';
export const VIDEO_THEME_CLIP_API_URL = '/v1/videothemeclip';
export const EVENT_TYPE_URL = '/v1/eventtype';
export const VIDEO_THEME_TEXT_API_URL = '/v1/videothemetext';
export const CUSTOM_ATTRIBUTE_TEMPLATE_URL = '/v1/customattributetemplate';
export const CUSTOM_ATTRIBUTE_VALUE_URL = '/v1/customattributevalue';
export const STREAM_INVITATION_API_URL = '/v1/streaminvitation';
export const STREAM_EVENT_API_URL = '/v1/streamevent';
export const STOCK_CLIP_API_URL = '/v1/stockclip';
export const TEXT_OVERLAY_API_URL = '/v1/textoverlay';
export const PAYMENT_PLAN_API_URL = '/v1/paymentplan';
export const ORGANIZATION_PERMISSIONS_API_URL = '/v1/organizationpermission';
export const TRIBUTE_VIDEO_EXPORT_API_URL = '/v1/tributevideoexport';
export const MOVEMENT_BUNDLES = 'getmovementbundles';
export const GENERATE_CUSTOM_VALUE = 'generatecustomvalue';
export const PLAYLIST_API_URL = '/v1/playlist';
export const SERVICE_MESSAGE_API_URL = '/v1/servicemessage';
export const EVENT_LOG_API_URL = '/v1/eventlog';
export const PLAYER_RELEASE_API_URL = '/v1/playerrelease';
export const SCREEN_API_URL = '/v1/screen';
export const REGISTRATION_API_URL = '/v1/registration';
export const SUPPORT_CHAT_API_URL = '/v1/supportchat';

//queries
export const ALL_DEVICES_QUERY_KEY = 'getAllDevices';
export const ALL_DEVICE_SCHEDULE_QUERY_KEY = 'getAllDeviceSchedules';
export const ALL_EVENTS_QUERY_KEY = 'getAllEvents';
export const ALL_ORGS_QUERY_KEY = 'getAllOrganizations';
export const ALL_CEREMONY_TEMPLATES_QUERY_KEY = 'getAllTemplates';
export const CEREMONY_TEMPLATE_BY_ID_QUERY_KEY = 'ceremonyTemplateById';
export const ALL_CEREMONY_SLOT_TYPES_QUERY_KEY = 'getAllCeremonySlotTypes';
export const ALL_USERS_QUERY_KEY = 'getAllUsers';
export const ALL_VIDEO_THEME_QUERY_KEY = 'getAllVideoTheme';
export const ALL_VIDEO_THEME_CLIP_QUERY_KEY = 'getAllVideoThemeClip';
export const ALL_VIDEO_THEME_TEXT_QUERY_KEY = 'getAllVideoThemeText';
export const ALL_CUSTOM_VIDEO_THEME_QUERY_KEY = 'getAllCustomVideoTheme';
export const ALL_PAYMENT_PLANS_QUERY_KEY = 'getAllPaymentPlans';
export const ALL_PLAYLISTS_QUERY_KEY = 'getAllPlaylists';
export const ALL_ORGANIZATION_PERMISSIONS_QUERY_KEY = 'getAllOrganizationsPermissions';
export const ALL_TRIBUTE_VIDEO_EXPORTS_QUERY_KEY = 'getAllTributeVideoExports';
export const VIDEO_THEME_BY_ID_QUERY_KEY = 'videoThemeById';
export const CUSTOM_VIDEO_THEME_BY_ID_QUERY_KEY = 'customVideoThemeById';
export const CLIP_BY_VIDEO_THEME_ID_QUERY_KEY = 'getClipByVideoThemeId';
export const VIDEO_THEME_CLIP_BY_ID_QUERY_KEY = 'videoThemeClipById';
export const VIDEO_THEME_TEXT_BY_ID_QUERY_KEY = 'videoThemeTextById';
export const ASSET_BY_ID_QUERY_KEY = 'assetById';
export const STOCK_CLIP_BY_ID_QUERY_KEY = 'stockClipById';
export const STOCK_CLIP_BY_ASSET_ID_QUERY_KEY = 'stockClipByAssetId';
export const ASSET_SLOT_QUERY_KEY = 'assetSlot';
export const ASSET_SLOT_EVENT_QUERY_KEY = 'assetSlotEvent';
export const COVER_PHOTO_BY_ID_QUERY_KEY = 'coverPhotoById';
export const CURRENT_USER_QUERY_KEY = 'getcurrentuser';
export const DEVICE_BY_ID_QUERY_KEY = 'deviceById';
export const DEVICE_SCHEDULE_BY_SCREEN_ID_QUERY_KEY = 'deviceScheduleByScreenId';
export const DEVICE_SCHEDULE_BY_ID_QUERY_KEY = 'deviceScheduleById';
export const DOWNLOAD_SONG_QUERY_KEY = 'downloadSong';
export const STREAM_EVENT_BY_TOKEN_QUERY_KEY = 'streamEventById';
export const STREAM_EVENT_BY_TOKEN_QUERY_KEY_TWO = 'streamEventByToken';
export const EVENT_BY_ID = 'event';
export const ORG_BY_ID_SIMPLIFIED_QUERY_KEY = 'organizationByIdSimplified';
export const EVENT_BY_ID_QUERY_KEY = 'eventById';
export const GET_EVENT_ASSETS = 'getEventAssets';
export const GET_ORGANIZATION_ASSETS = 'getOrganizationAssets';
export const GET_VIDEO_THEME_CLIPS = 'getVideoThemeClips';
export const GET_VIDEO_THEME_TEXTS = 'getVideoThemeTexts';
export const GET_EVENT_COVER_PHOTOS = 'getEventCoverPhotos';
export const GET_EVENT_TAGS = 'getEventTags';
export const GET_EVENT_TRIBUTE_VIDEOS = 'getEventTributeVideos';
export const GET_STOCK_CLIPS = 'getStockClips';
export const GET_TEXT_OVERLAY_QUERY_KEY = 'getTextOverlay';
export const GET_TEXT_OVERLAY_BY_ID_QUERY_KEY = 'getTextOverlayById';
export const GET_PAYMENT_PLANS = 'getPaymentPlans';
export const ORG_BY_ID_QUERY_KEY = 'OrganizationById';
export const ORGANIZATION_BRANDING_BY_ID_QUERY_KEY = 'organizationBrandingByOrganizationId';
export const PAYMENT_PLAN_BY_ID_QUERY_KEY = 'PaymentPlanById';
export const PREVIEW_MUSIC_QUERY_KEY = 'previewMusic';
export const ROLES_QUERY_KEY = 'roles';
export const SEARCH_MUSIC_QUERY_KEY = 'searchMusic';
export const TRIBUTE_VIDEO_BY_ID_QUERY_KEY = 'tributeVideoById';
export const USER_BY_ID_QUERY_KEY = 'userById';
export const USER_QUERY_KEY = 'user';
export const ALL_SCREENS_QUERY_KEY = 'getAllScreens';
export const ALL_EVENT_TYPES = 'getAlleventTypes';
export const EVENT_TYPES_BY_ORGANIZATION = 'getEventTypesByOrganization';
export const GET_CUSTOM_ATTRIBUTE_TEMPLATES_BY_EVENT_TYPE =
  'getCustomAttributeTemplatesByEventType';
export const GET_EVENT_TYPE_CUSTOM_ATTRIBUTE_TEMPLATE = 'getEventTypeByCustomAttributeTemplate';
export const GET_CUSTOM_ATTRIBUTES_BY_EVENT_ID = 'getCustomAttributesByEventId';
export const GET_TRIBUTE_VIDEO_EXPORT_STATUS_QUERY_KEY = 'getTributeVideoExportStatus';
export const LIVE_STREAM_LINK_BY_ID_QUERY_KEY = 'getLiveStreamLinkByEventId';
export const ALL_STREAM_INVITATIONS_QUERY_KEY = 'getAllStreamInvitations';
export const UPLOAD_PROFILE_PICTURE_QUERY_KEY = 'uploadProfilePicture';
export const SAS_TOKEN_PROFILE_PICTURE_QUERY_KEY = 'sasTokenProfilePicture';
export const CREATE_CEREMONY_TEMPLATE = 'createCeremonyTemplate';
export const TEXT_BY_VIDEO_THEME_ID_QUERY_KEY = 'getTextByVideoThemeId';
export const USER_INVITATION_LINK = 'invitationLink';
export const USER_INVITATION_OPTIONS = 'invitationOptions';
export const CANCEL_EXPORT_RENDERING = 'cancelExportRendering';
export const ALL_MOVEMENT_BUNDLES_QUERY_KEY = 'getAllMovementBundles';
export const PLAYLIST_BY_ID_QUERY_KEY = 'playlistById';
export const PLAYLISTS_COUNT_QUERY_KEY = 'playlistCount';
export const SERVICE_MESSAGE_QUERY_KEY = 'serviceMessages';
export const GET_SERVICE_MESSAGE_QUERY_KEY = 'getServiceMessages';
export const GET_ACTIVE_SERVICE_MESSAGE_QUERY_KEY = 'getActiveServiceMessages';
export const SUPPORT_CONVERSATION_QUERY_KEY = 'supportConversation';
export const ALL_PLAYER_RELEASES_QUERY_KEY = 'getAllPlayerReleases';
export const PLAYER_RELEASE_BY_ID_QUERY_KEY = 'getPlayerReleaseById';
export const GET_STATUS_OVERVIEW_QUERY_KEY = 'statusOverview';
export const GET_NUMBER_OVERVIEW_QUERY_KEY = 'numberOverview';
export const GET_WEEKLY_EXPORTS_QUERY_KEY = 'weeklyExports';
export const GET_TRIBUTE_VIDEO_BY_ASSET_ID_QUERY_KEY = 'tributeVideoByAssetId';
